import type { ComponentProps } from "react"
import type { VariantProps } from "class-variance-authority"
import { RadioGroupItem as RadioGroupItemBase } from "@/v2-ui/radioGroup/base/RadioGroupBase"
import cn from "@/v2-ui/utils/utils.cn"
import { radioGroupItemVariant } from "./radio.group.constants"

export type RadioGroupItemProps = ComponentProps<typeof RadioGroupItemBase> &
  VariantProps<typeof radioGroupItemVariant>

function RadioGroupItem(props: RadioGroupItemProps) {
  const { className, size, ...radioGroupItemBaseProps } = props
  return (
    <RadioGroupItemBase
      className={cn(
        "ui-radio-group-item",
        radioGroupItemVariant({ className, size: size }),
      )}
      {...radioGroupItemBaseProps}
    />
  )
}

export default RadioGroupItem
